import { render, staticRenderFns } from "./AdvertisingSpace.vue?vue&type=template&id=220aed66&"
import script from "./AdvertisingSpace.vue?vue&type=script&lang=js&"
export * from "./AdvertisingSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports